import * as angular from 'angular';

import { ComponentDefinition, IdentifierType } from '../../models';
import { ICalculatedStateParams } from '..';
import { IGroupService } from '../../services';
import { tagDefaultState, validatedDefaultState, calculatedDefaultState, targetDefaultState } from '../../common';

class LinkedStateController {
    static controllerId = 'LinkedState';

    static $inject = ['$state', '$stateParams', 'groupService'];

    constructor(
        private $state: angular.ui.IStateService,
        private $stateParams: ICalculatedStateParams,
        private groupService: IGroupService) {
    }

    $onInit() {

        const linkedGuid = this.$stateParams['linkedGuid'];
        if (linkedGuid) {
            this.groupService.getIdentifier(linkedGuid).then(identifier => {

                let newState: string;

                switch (identifier.type) {
                    case IdentifierType.Tag:
                        newState = tagDefaultState;
                        break;
                    case IdentifierType.CalculatedValue:
                        newState = calculatedDefaultState;
                        break;
                    case IdentifierType.Linked:
                        newState = 'linked';
                        break;
                    case IdentifierType.Validated:
                        newState = validatedDefaultState;
                        break;
                    case IdentifierType.Target:
                        newState = targetDefaultState;
                        break;
                    default:
                        newState = 'notFound';
                }

                this.$state.go(newState, { identifierGuid: identifier.guid, tagDefinitionGuid: identifier.tagDefinitionGuid, linkedGuid: identifier.linkedGuid }, { location: true });
            });
        }
    }
}

export const wtLinkedState: ComponentDefinition = {
    componentId: 'wtLinkedState',
    controller: LinkedStateController,
    controllerAs: 'vm',
    bindings: {
    }
};